// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReportCloseDto
 */
export interface IReportCloseDto {
    /**
     * 
     * @type {number}
     * @memberof IReportCloseDto
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IReportCloseDto
     */
    started_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IReportCloseDto
     */
    ended_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof IReportCloseDto
     */
    period_type?: IReportCloseDtoPeriodTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IReportCloseDto
     */
    previous_close_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IReportCloseDto
     */
    status?: IReportCloseDtoStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IReportCloseDtoPeriodTypeEnum {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
    QUARTERLY = 'QUARTERLY',
    ANNUALLY = 'ANNUALLY'
}
/**
* @export
* @enum {string}
*/
export enum IReportCloseDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED',
    CLOSING = 'CLOSING',
    PENDING_CLOSE = 'PENDING_CLOSE',
    FAILED = 'FAILED'
}


/**
 * Check if a given object implements the IReportCloseDto interface.
 */
export function instanceOfIReportCloseDto(value: object): value is IReportCloseDto {
    return true;
}

export function IReportCloseDtoFromJSON(json: any): IReportCloseDto {
    return IReportCloseDtoFromJSONTyped(json, false);
}

export function IReportCloseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportCloseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'started_on': json['started_on'] == null ? undefined : (new Date(json['started_on'])),
        'ended_on': json['ended_on'] == null ? undefined : (new Date(json['ended_on'])),
        'period_type': json['period_type'] == null ? undefined : json['period_type'],
        'previous_close_id': json['previous_close_id'] == null ? undefined : json['previous_close_id'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function IReportCloseDtoToJSON(json: any): IReportCloseDto {
    return IReportCloseDtoToJSONTyped(json, false);
}

export function IReportCloseDtoToJSONTyped(value?: IReportCloseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'started_on': value['started_on'] == null ? undefined : ((value['started_on']).toISOString()),
        'ended_on': value['ended_on'] == null ? undefined : ((value['ended_on']).toISOString()),
        'period_type': value['period_type'],
        'previous_close_id': value['previous_close_id'],
        'status': value['status'],
    };
}

